import { Enum, EnumType } from 'ts-jenum';

@Enum<FreeBusyStateEnum>('value')
export class FreeBusyStateEnum extends EnumType<FreeBusyStateEnum>() {
   static readonly FREE = new FreeBusyStateEnum(0, 'free-busy-state-free');
   static readonly TENTATIVE = new FreeBusyStateEnum(1, 'free-busy-state-tentative');
   static readonly BUSY = new FreeBusyStateEnum(2, 'free-busy-state-busy');
   static readonly OOF = new FreeBusyStateEnum(3, 'free-busy-state-oof');
   static readonly WORKING_ELSE_WHERE = new FreeBusyStateEnum(4, 'free-busy-state-working-else-where');
   static readonly NO_DATA = new FreeBusyStateEnum(5, 'free-busy-state-no-data');

   private constructor(public value: number, public cssClass: string) {
      super();
   }
}
